import { formatErrorMessage } from "utils/handle-error"

export const proccessErro = (showFeedback, e) => {
  showFeedback(formatErrorMessage(e))
}